import React from "react";
import OutFooter from "../components/OutFooter/OutFooter.js";
// import OutFooter from "../components/Footer/OutFooter.js";
import { Route } from "react-router-dom";
import { apiCall } from '../Service/ConnectToServer.js';
import routes from "../routes.js";

class Error403 extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            IsLoading:true,
            siteSetting:{}
            
        }
     
    }

    getRoutes = (routes) => {
        return routes.map((prop, key) => {
            return (
                <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                />
                
            );
        });
    };

 getBrandText = (path) => {
    // console.log(this.state.siteSetting);
    return  "سامانه پرداخت الکترونیکی عوارض"+this.state.siteSetting.SiteTitle
        // for (let i = 0; i < routes.length; i++) {
        //   if ( window.location.pathname.indexOf(routes[i].path) !== -1) {
        //     return  this.state.siteSetting.SiteTitle+" | "+routes[i].rtlName;
        //   }
        // }
        // return "سامانه پرداخت الکترونیکی عوارض";
      };
      componentDidMount(){

        let head = document.head;
        let meta1 = document.createElement("meta");
        let meta2 = document.createElement("meta");
        meta1.name = "description";
        meta2.name = "keywords";

        const config = {
            method: "Post",
            url: "User/GetUserSiteSetting",
            Authorization: true,
            data: {}
        }

        apiCall(config, (response) => {
            // const domain = window.location.host.replace(/.+\/\/|www.|\..+/g, '').replace('/','');
            // const resultDomain=response.data.Result.Domain.replace(/.+\/\/|www.|\..+/g, '').replace('/','');
          // console.log("response"+response.data.Result.SiteTitle);
         
            this.setState({
                siteSetting:response.data.Result
            },()=>{this.MetaTagAdd();});
            if(resultDomain===domain){
                if(response.data.Result.State===2 || response.data.Result.State===3){
                   this.props.history.push({
                        pathname:"/403",
                        state:{
                            title: ` سایت ${response.data.Result.SiteTitle}از دسترس خارج شده است `,
                            text: 'لطفا با پشتیبانی تماس بگیرید  \n '+response.data.Result.DehyariPhoneNumber
                         }
                       });
                }
                else{
                    this.setState({
                        IsLoading:false
                    })
            if (response.data.Result.SiteHeader == null ||
                response.data.Result.SiteHeader === "") {
                response.data.Result.SiteHeader = "سامانه پرداخت الکترونیکی عوارض"
            }
          //  document.title= response.data.Result.SiteTitle;
            this.setState({
                siteSetting:response.data.Result
            });
      
            meta1.content=response.data.Result.DescriptionMeta;
            meta2.content=response.data.Result.KeywordsMeta;
            head.appendChild(meta1);
            head.appendChild(meta2);
           // manifestDynamic(response.data.Result.DehyariAddress,
              //  response.data.Result.SiteTitle,response.data.Result.HeaderLogoUrl)
            }}
        else{
            document.title= response.data.Result.SiteTitle;
            this.props.history.push({
                pathname:"/403",
                state:{
                    title: 'عملیات ناموفق',
                    text: 'کد دسترسی به دامنه سایت تعلق ندارد'
                 }
               });
        }
        }, (err) => {
            Swal.fire({
                title: 'عملیات ناموفق',
                text: err,
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        });
        this.MetaTagAdd();
    }

   MetaTagAdd=() => {
        // on this page, we need on the body tag the classes .rtl and .menu-on-right
        document.body.classList.add("rtl", "menu-on-right");
        // we also need the rtl bootstrap
        // so we add it dynamically to the head
        let head = document.head;
        let link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "rtl-id";
        link.href=require("../assets/css/Rtl.css").default;
        head.appendChild(link);
        // Specify how to clean 

        //document.title = this.getBrandText(window.location.pathname);
        document.title = this.getBrandText(window.location.pathname);

        // Specify how to clean up after this effect:
        return function cleanup() {
            // when we exit this page, we need to delete the classes .rtl and .menu-on-right
            // from the body tag
            document.body.classList.remove("rtl", "menu-on-right");
            // we also need to delete the rtl bootstrap, so it does not break the other pages
            // that do not make use of rtl
            document.getElementById("rtl-id").remove();
        };
    };

    render(){
        const {IsLoading,siteSetting,sidebarOpened}=this.state;
        return (
            <>
             <div className="content text-right" style={{direction:'rtl',backgroundColor: '#e7eaf1',paddingBottom:'60px'}}>
                <div style={{paddingTop:'80px'}}></div>
                    <div className="row col-md-12">
                        <div className="col-md-6" style={{backgroundImage:require('../assets/img/deny.png').default}}>

                            {(this.props.location.state && this.props.location.state!=null)?
                                        <div className="landing-page" style={{margin:'0px 60px 40px 40px'}}>
                                        <h3>کاربر گرامی</h3>

                            <span style={{textAlign:'center',fontSize:'23px',color:'red',marginBottom:'25px',fontWeight:'bolder'}}>{this.props.location.state.title}</span>
                            <span style={{textAlign:'center',fontSize:'18px',color:'blue',marginBottom:'15px',fontWeight:'bolder'}}>{this.props.location.state.text}</span>
                            </div>
                            :""}
                
                        </div>
                        <div className="col-md-6">
                            <img alt=" Not load" src={require("../assets/img/deny.png").default}></img>
                        </div>
                    </div>
             </div>
               <OutFooter 
                       siteSetting={siteSetting}
                />
            </>
        )

    }

} 

// function Error403(props) {
//     return (
//         <>
//             <div className="content text-right" style={{direction:'rtl',backgroundColor: '#e7eaf1',paddingBottom:'60px'}}>
//                 <div style={{paddingTop:'80px'}}></div>
//     <div className="row col-md-12">
//         <div className="col-md-6" style={{backgroundImage:require('../assets/img/deny.png').default}}>

//                {(props.location.state && props.location.state!=null)?
//                            <div className="landing-page" style={{margin:'0px 60px 40px 40px'}}>
//                            <h3>کاربر گرامی</h3>
//             <span style={{textAlign:'center',fontSize:'23px',color:'red',marginBottom:'25px',fontWeight:'bolder'}}>{props.location.state.title}</span>
//             <span style={{textAlign:'center',fontSize:'18px',color:'blue',marginBottom:'15px',fontWeight:'bolder'}}>{props.location.state.text}</span>
//             </div>
//             :""}
  
//         </div>
//         <div className="col-md-6">
//             <img alt=" Not load" src={require("../assets/img/deny.png").default}></img>
//         </div>
//     </div>
//            </div>

       

//         </>
//     );
// }

export default Error403;
